<template>
  <div class="footer-main">
    <div class="content">
      <div class="footer-top-row">
        <div class="footer-sub-view">
          <div class="l1-title">
            友情链接
          </div>
          <div class="l2-text">
            <a href="https://ebook.uestcp.com.cn" target="_blank">云书平台</a>
          </div>
          <div class="l2-text">
            <a href="https://4yfyrn6v.mh.chaoxing.com/ " target="_blank">超星平台</a>
          </div>
          <div class="l2-text">
            <a href="https://uestcp.lessonplan.cn" target="_blank">舟道平台</a>
          </div>
          <div class="l2-text">
            <a href="https://binguoketang.com/#/publisher/login/914" target="_blank">文轩缤果平台</a>
          </div>
          <div class="l2-text">
            <a href="https://szcb.uestcp.com.cn/booksite/index-aero.html" target="_blank">平台简介</a>
          </div>
        </div>
        <!-- <div class="footer-sub-view">
          <div class="l2-text"  style="margin-top: 0px;" href="/">
            <a href="/">首页</a>
          </div>
          <a class="l2-text">
            数字教材
          </a>
          <div class="l2-text">
            纸质图书
          </div>
        </div> -->
        <!-- <div class="footer-sub-view">
          <a class="l2-text" style="margin-top: 0px;" href="/booklist">
            线上书城
          </a>
          <a class="l2-text" href="/userspace">
            个人中心
          </a>
        </div> -->
        <div class="footer-sub-view">
          <div class="l1-title">
            联系我们
          </div>
          <div class="l2-text" style="display:flex;flex-direction:row;align-items: center; line-height: 20px;">
            <img src="../assets/icon_tel_normal.png" alt="" style="width:20px;height:20px; margin-right: 5px;">
            <div style="line-height: 20px;height:20px">400-820-8820</div>
          </div>
          <div class="l2-text" style="display:flex;flex-direction:row;align-items: center; line-height: 20px;">
            <img src="../assets/icon_mail_normal.png" alt="" style="width:20px;height:20px; margin-right: 5px;">
            <div style="line-height: 20px;height:20px;">1213456@qq.com</div>
          </div>

        </div>
        <div class="footer-qr-group">
          <div class="footer-sub-view footer-sub-view--qr">
            <img src="/uestcp_wechat.png" alt="" class="qr-img">
            <div class="qr-text">扫码关注官方微信</div>
          </div>
          <div class="footer-sub-view footer-sub-view--qr">
            <img src="/uestcp_weibo.png" alt="" class="qr-img">
            <div class="qr-text">扫码关注官方微博</div>
          </div>
        </div>
      </div>
      <div class="line-view"></div>
      <div class="bottom-view">
        <div class="text1">
          版权声明
        </div>
        <div class="text1" style="margin-left: 20px;">
          公安备案号：京公网安备11010202007176号
        </div>
        <div class="text1" style="margin-left: 20px;">
          电子出版物出版许可证：（总）电出证（京）字第010号
        </div>
        <div class="text1" style="margin-left: auto">
          电子科技大学出版社@2013
        </div>
        <div class="text1" style="margin-left: 20px;margin-right: 0px;font-weight: bold;color:#191919">
          蜀ICP13021456号-1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
@import '@/styles/layout.less';

.footer-main {
  display: flex;
  flex-direction: column;
  min-height: 306px;
  background: #F6F6F6;
  justify-content: center;
  align-items: center;

  .content {
    display: flex;
    flex-direction: column;
    .page-container();
  }

  .footer-top-row {
    display: flex;
    flex-direction: row;
    width: 100%;
    min-width: 0;
    flex-wrap: wrap;
  }

  .line-view {
    height: 1px;
    width: 100%;
    background: #707070;
    margin-top: 30px;
  }

  .bottom-view {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    min-width: 0;
    width: 100%;
    gap: 0 12px;
    justify-content: flex-start;

    .text1 {
      font-weight: 400;
      font-size: 15px;
      color: #999999;
      margin-top: 15px;
      text-align: center;
    }
  }

  .qr-img {
    width: 154px;
    height: 154px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .footer-qr-group {
    display: flex;
    flex: 2;
    min-width: 0;
    gap: 24px;
  }

  .footer-sub-view--qr {
    align-items: flex-end;
    flex: 1;
    min-width: 140px;
  }

  .footer-sub-view {
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    flex: 1;
    min-width: 140px;

    .l1-title {
      font-weight: 400;
      font-size: 18px;
      color: #191919;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .l2-text {
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 20px;

      a {
        color: #666666;
      }
    }

    .qr-text {
      width: 154px;
      max-width: 100%;
      margin-top: 8px;
      font-size: 14px;
      color: #666666;
      text-align: center;
      line-height: 20px;
    }
  }

  .tablet-down({
    min-height: auto;
    padding: 24px 0;

    .qr-img {
      width: 120px;
      height: 120px;
    }

    .footer-sub-view .qr-text {
      width: 120px;
    }

    .footer-sub-view .l1-title,
    .footer-sub-view .l2-text {
      font-size: 15px;
    }

    .bottom-view .text1 {
      font-size: 13px;
      margin-left: 0 !important;
    }

    .bottom-view .text1:last-child {
      margin-right: 0 !important;
    }

    .footer-sub-view {
      margin-top: 28px;
    }

    .bottom-view {
      justify-content: center;
    }
  });

  .mobile-down({
    min-height: auto;
    padding: 28px 0 20px;

    .content {
      padding-left: 16px;
      padding-right: 16px;
    }

    .footer-top-row {
      flex-direction: column;
    }

    .footer-sub-view {
      flex: none;
      width: 100%;
      min-width: 0;
      margin-top: 24px;
      align-items: flex-start;

      .l1-title {
        font-size: 16px;
        font-weight: 600;
      }

      .l2-text {
        font-size: 14px;
        margin-top: 12px;
        line-height: 22px;
      }
    }

    .footer-sub-view:first-child {
      margin-top: 0;

      // 友情链接：手机端两列排布
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 12px;
      row-gap: 4px;

      .l1-title {
        grid-column: 1 / -1;
        margin-bottom: 4px;
      }
    }

    .footer-qr-group {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      width: 100%;
      flex: none;
      justify-content: space-around;
      align-items: flex-start;
      gap: 24px;
      margin-top: 8px;
      box-sizing: border-box;
    }

    .footer-sub-view.footer-sub-view--qr {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: auto;
      max-width: 130px;
      min-width: 0;
      margin-top: 16px;
      flex: 0 0 auto;

      .qr-img {
        display: block;
        width: 110px;
        height: 110px;
      }

      .qr-text {
        display: block;
        width: 110px;
        margin-top: 8px;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        white-space: nowrap;
      }
    }

    .line-view {
      margin-top: 24px;
    }

    .bottom-view {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;

      .text1 {
        margin-top: 0;
        margin-left: 0 !important;
        margin-right: 0 !important;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
      }
    }
  });

}
</style>